import sanctum from '../http/requests/auth/sanctum';
export default (to, from, next) => {
  if (sanctum.isAuth()) {
    next('/');
    return false;
  }
};
